import { useEffect } from "react";
import aa from "search-insights";
import {
  hasCookieConsent,
  getGoogleAnalyticsUserIdFromBrowserCookie,
} from "../../../util";

type AlgoliaInsightsProps = {
  appId: string;
  apiKey: string;
};

export function AlgoliaInsights({ appId, apiKey }: AlgoliaInsightsProps) {
  useEffect(() => {
    const getUserToken = () => {
      if (hasCookieConsent("analytics")) {
        // If analytics cookies are accepted, use GA token
        const gaToken = getGoogleAnalyticsUserIdFromBrowserCookie("_ga");
        if (gaToken) {
          return gaToken.replace(".", "_");
        }
      }
      return;
    };

    const userToken = getUserToken();

    const initOptions = {
      appId,
      apiKey,
      useCookie: true,
      ...(userToken ? { userToken } : {}),
    };

    aa("init", initOptions);
  }, [appId, apiKey]);

  return null;
}

export default AlgoliaInsights;
